/** Global MUI RTL overrides for Persian form labels and inputs */

export const rtlFormComponentOverrides = {
  MuiFormControl: {
    styleOverrides: {
      root: {
        direction: 'rtl',
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      root: {
        right: 14,
        left: 'auto',
        transformOrigin: 'top right',
        textAlign: 'right',
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        right: 14,
        left: 'auto',
        transformOrigin: 'top right',
        textAlign: 'right',
      },
      shrink: {
        transform: 'translate(-14px, -9px) scale(0.75)',
      },
      outlined: {
        '&.MuiInputLabel-shrink': {
          transform: 'translate(-14px, -9px) scale(0.75)',
        },
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        direction: 'rtl',
        '& .MuiOutlinedInput-notchedOutline legend': {
          textAlign: 'right',
        },
      },
      input: {
        textAlign: 'right',
      },
      notchedOutline: {
        textAlign: 'right',
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        direction: 'rtl',
      },
      input: {
        textAlign: 'right',
      },
    },
  },
  MuiSelect: {
    defaultProps: {
      MenuProps: {
        PaperProps: {
          sx: { direction: 'rtl' },
        },
      },
    },
    styleOverrides: {
      icon: {
        right: 'auto',
        left: 7,
      },
      select: {
        textAlign: 'right',
        paddingRight: '14px !important',
        paddingLeft: '32px !important',
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        textAlign: 'right',
        justifyContent: 'flex-start',
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiInputLabel-root': {
          right: 14,
          left: 'auto',
          transformOrigin: 'top right',
          textAlign: 'right',
        },
        '& .MuiOutlinedInput-root': {
          direction: 'rtl',
        },
      },
    },
  },
};
